// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FormField {
  flex-wrap: nowrap;
  flex-grow: 1;
  padding: 0;
  width: 100%;
  position: relative;
}
.FormField:not(.condensed) {
  margin: 1.2rem 0;
}
.FormField .input-group {
  flex-wrap: nowrap;
}
.FormField .input-group .FormField-Label {
  height: 100%;
}
.FormField .FormField-Label {
  display: inline-flex;
  flex-wrap: nowrap;
  text-transform: uppercase;
  font-size: 0.8rem;
  padding-top: 0;
  padding-bottom: 0;
  text-align: right;
  line-height: 0.8rem;
}
.FormField .FormField-Label.form-text {
  color: var(--bs-gray);
  font-weight: bold;
}
.FormField .FormField-Label sup {
  line-height: 0;
}
.FormField:not(.inline) .FormField-Label {
  position: relative;
  padding: 0 0.25rem;
  margin-left: 0.5rem;
  border-bottom: 0.25rem solid #fff;
  line-height: 0.6rem;
  z-index: 50;
  font-weight: 600;
  border-radius: 0.25rem 0.25rem 0 0;
  height: 0.7rem;
}
.FormField:not(.inline) .FormField-Label + .FormField-Wrapper {
  margin-top: -0.5rem;
}
.FormField .FormField-Wrapper {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  position: relative;
}
.FormField .FormField-Wrapper.h-full {
  height: 100%;
}
.FormField .FormField-Wrapper .FormField-Input.form-switch {
  height: 2.25rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 3rem;
}
.FormField .FormField-Wrapper .FormField-Input.form-switch > input {
  transform: scale(1.5);
}
.FormField .FormField-Wrapper .FormField-Feedback {
  position: absolute;
  bottom: -1.5rem;
}
.FormField .FormField-Wrapper .FormField-Feedback.default-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
}
.FormField .form-check-input ~ .form-check-label,
.FormField .form-check-input ~ .form-check-label {
  transform: translate(0, 0.1rem);
}
.FormField .form-check-input.is-valid ~ .form-check-label,
.FormField .form-check-input.is-invalid ~ .form-check-label {
  color: var(--bs-body-color);
}
.FormField .form-switch > .form-check-input ~ .form-check-label {
  transform: translate(0, -0.2rem);
  margin-left: 0.5rem;
}
.FormField .grouped-input {
  border: 1px solid var(--bs-secondary-subtle);
}
.FormField .grouped-input input {
  border: none;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.FormField .grouped-input .input-group-text {
  border: none;
}
.FormField .grouped-input .input-group-text:first-of-type, .FormField .grouped-input .input-group-text + .input-group-text {
  border-left: 1px solid var(--bs-secondary-subtle);
}
.FormField .grouped-input .input-group-text:first-of-type, .FormField .grouped-input .input-group-text:first-of-type > button, .FormField .grouped-input .input-group-text + .input-group-text, .FormField .grouped-input .input-group-text + .input-group-text > button {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/FormField/styles.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AACF;AAAE;EACE,gBAAA;AAEJ;AAAE;EACE,iBAAA;AAEJ;AADI;EACE,YAAA;AAGN;AAAE;EACE,oBAAA;EACA,iBAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;AAEJ;AADI;EACE,qBAAA;EACA,iBAAA;AAGN;AADI;EACE,cAAA;AAGN;AACI;EACE,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iCAAA;EACA,mBAAA;EACA,WAAA;EACA,gBAAA;EACA,kCAAA;EACA,cAAA;AACN;AAAM;EACE,mBAAA;AAER;AAEE;EACE,aAAA;EACA,sBAAA;EACA,YAAA;EACA,kBAAA;AAAJ;AACI;EACE,YAAA;AACN;AAEM;EACE,eAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AAAR;AACQ;EACE,qBAAA;AACV;AAGI;EACE,kBAAA;EACA,eAAA;AADN;AAEM;EACE,cAAA;EACA,WAAA;EACA,mBAAA;EACA,kBAAA;AAAR;AAIE;;EAEE,+BAAA;AAFJ;AAIE;;EAEE,2BAAA;AAFJ;AAIE;EACE,gCAAA;EACA,mBAAA;AAFJ;AAIE;EACE,4CAAA;AAFJ;AAGI;EACE,YAAA;EACA,0BAAA;EACA,6BAAA;AADN;AAGI;EACE,YAAA;AADN;AAEM;EAEE,iDAAA;AADR;AAEQ;EAEE,yBAAA;EACA,4BAAA;AADV","sourcesContent":[".FormField {\n  flex-wrap: nowrap;\n  flex-grow: 1;\n  padding: 0;\n  width: 100%;\n  position: relative;\n  &:not(.condensed) {\n    margin: 1.2rem 0;\n  }\n  .input-group {\n    flex-wrap: nowrap;\n    .FormField-Label {\n      height: 100%;\n    }\n  }\n  .FormField-Label {\n    display: inline-flex;\n    flex-wrap: nowrap;\n    text-transform: uppercase;\n    font-size: 0.8rem;\n    padding-top: 0;\n    padding-bottom: 0;\n    text-align: right;\n    line-height: 0.8rem;\n    &.form-text {\n      color: var(--bs-gray);\n      font-weight: bold;\n    }\n    sup {\n      line-height: 0;\n    }\n  }\n  &:not(.inline) {\n    .FormField-Label {\n      position: relative;\n      padding: 0 0.25rem;\n      margin-left: 0.5rem;\n      border-bottom: 0.25rem solid #fff;\n      line-height: 0.6rem;\n      z-index: 50;\n      font-weight: 600;\n      border-radius: 0.25rem 0.25rem 0 0;\n      height: 0.7rem;\n      + .FormField-Wrapper {\n        margin-top: -0.5rem;\n      }\n    }\n  }\n  .FormField-Wrapper {\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n    position: relative;\n    &.h-full {\n      height: 100%;\n    }\n    .FormField-Input {\n      &.form-switch {\n        height: 2.25rem;\n        padding-top: 0.5rem;\n        padding-bottom: 0.5rem;\n        padding-left: 3rem;\n        > input {\n          transform: scale(1.5);\n        }\n      }\n    }\n    .FormField-Feedback {\n      position: absolute;\n      bottom: -1.5rem;\n      &.default-feedback {\n        display: block;\n        width: 100%;\n        margin-top: 0.25rem;\n        font-size: 0.875em;\n      }\n    }\n  }\n  .form-check-input ~ .form-check-label,\n  .form-check-input ~ .form-check-label {\n    transform: translate(0, 0.1rem);\n  }\n  .form-check-input.is-valid ~ .form-check-label,\n  .form-check-input.is-invalid ~ .form-check-label {\n    color: var(--bs-body-color);\n  }\n  .form-switch > .form-check-input ~ .form-check-label {\n    transform: translate(0, -0.2rem);\n    margin-left: 0.5rem;\n  }\n  .grouped-input {\n    border: 1px solid var(--bs-secondary-subtle);\n    input {\n      border: none;\n      border-top-right-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n    .input-group-text {\n      border: none;\n      &:first-of-type,\n      & + .input-group-text {\n        border-left: 1px solid var(--bs-secondary-subtle);\n        &,\n        & > button {\n          border-top-left-radius: 0;\n          border-bottom-left-radius: 0;\n        }\n      }\n    }\n  }\n  // @media (max-width: 1280px) {\n  //   .prepend,\n  //   .append {\n  //     display: none;\n  //   }\n  // }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
